import React, { useEffect, useState } from 'react';
import "./account-ux.css";

import { AuthService } from "../../service/AuthService";
import { user, subscription as currentSubscription, toTitleCase } from "../../utils/Utils";
import { AppContext } from "../../HomePage";
import queryString from "query-string";

import AccountIdentityBar from "./AccountIdentityBar";
import AccountNav from "./AccountNav";
import { visibleSectionKeys } from "./AccountSections";

import AccountProfile from "./AccountProfile";   // created in Task 6
import Preferences from "./Preferences";          // created in Task 7
import Notification from "./Notification";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import TwoFactor from "./TwoFactor";
import Subscription from "./Subscription";
import BillingHistory from "./BillingHistory";
import SignInLogs from "./SignInLogs";
import ApiAccess from "./ApiAccess";

const Account = (props) => {
    const { t, location } = React.useContext(AppContext);

    const [account, setAccount] = useState(user() || { first_name: "", last_name: "", email: "" });
    // The header plan badge starts from the cached subscription but is refreshed
    // when the Subscription page loads a fresh one (e.g. after a Shopify plan
    // change), so the badge name stays in sync with the active plan.
    const [sub, setSub] = useState(currentSubscription());
    const visible = visibleSectionKeys();

    const initialKey = () => {
        const params = location ? queryString.parse(location.search) : {};
        if (params.subscription === "1" && visible.includes('subscription')) return 'subscription';
        if (params.section && visible.includes(params.section)) return params.section;
        return visible[0];
    };
    const [activeKey, setActiveKey] = useState(initialKey());

    useEffect(() => {
        if (!visible.includes(activeKey)) setActiveKey(visible[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSaved = (updated) => {
        AuthService.setUser(updated);
        setAccount({ ...updated });
    };

    const COMPONENTS = {
        profile:       <AccountProfile account={account} setAccount={setAccount} onSaved={onSaved} />,
        preferences:   <Preferences account={account} setAccount={setAccount} onSaved={onSaved} />,
        notifications: <Notification />,
        password:      <ChangePassword />,
        two_factor:    <TwoFactor />,
        signin:        <SignInLogs />,
        team:          <Profile />,
        subscription:  <Subscription onSubscriptionLoaded={setSub} />,
        billing:       <BillingHistory />,
        api:           <ApiAccess />,
    };

    const select = (key) => {
        setActiveKey(key);
        try {
            const hash = window.location.hash.split('?')[0];
            window.history.replaceState(null, "", `${hash}?section=${key}`);
        } catch (e) { /* history not critical */ }
    };

    const planLabel = (sub && sub.name) ? sub.name
        : (sub && sub.type) ? toTitleCase(sub.type)
        : t('account.plan.badge', 'Plan');

    return (
        <div className="account-hub">
            <AccountIdentityBar account={account} planLabel={planLabel}
                                onPlanClick={() => visible.includes('subscription') && select('subscription')} />
            <div className="acc-body">
                <AccountNav activeKey={activeKey} onSelect={select} />
                <div className="acc-content">
                    {COMPONENTS[activeKey] || COMPONENTS[visible[0]]}
                </div>
            </div>
        </div>
    );
};
export default Account;
